<template>
  <div  v-visible-track="'Iframe.ancientDnaGeneticDistanceMapsPageViewed'">
    <div class="pca-plots" v-if="$store.state.appConfig.windowWidth >= 769">
      <div class="result-container">
        <PcaPlotsSidebar />
      </div>
      <div class="map-container">
        <PcaPlotView />
      </div>
    </div>

    <div class="pca-plots-mobile" v-else>
      <PcaPlotsSidebar />
      <PcaPlotView class="mt-2"/>
    </div>
  </div>
</template>

<script>
import PcaPlotCalculateWatcher from './services/PcaPlotCalculateWatcher'
import PcaPlotsSidebar from './details/PcaPlotsSidebar.vue';
import PcaPlotView from './details/PcaPlotView.vue';

export default {
  components: {
    PcaPlotsSidebar,
    PcaPlotView,
  },
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
  },
  async mounted() {
    PcaPlotCalculateWatcher.init();
  },
  beforeDestroy() {
    PcaPlotCalculateWatcher.cleanup();
  },
};
</script>

<style lang="scss" scoped>
.pca-plots {
  width: 100%;
  height: 100vh;
  display: flex;

  .result-container {
    z-index: 1;
    display: inline-block;
    position: relative;
    width: 30%;
  }
  .map-container {
    flex-grow: 1;
    height: auto;
    position: relative;
  }
}

.pca-plots-mobile {
  flex-direction: column;
  display: flex;
  height: 100%;
  box-sizing: border-box;
}
</style>